export default __webpack_public_path__ + "madfit-screen-third@2x.57b2b936.png";